export default {"src":"/_next/static/media/secure-lock.18f89e59.svg","height":17,"width":13,"blurWidth":0,"blurHeight":0};